var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52855 0.477183C7.29331 0.662933 5.973 1.12333 4.9942 1.70981C1.3826 3.87369 -0.25512 7.77907 0.782957 11.7517C1.30596 13.7532 2.65412 16.4244 4.51259 19.1414C5.77193 20.9826 8.09855 23.8873 9.17393 24.9608C9.53937 25.3256 9.65383 25.3926 9.91222 25.3926C10.0803 25.3926 10.2783 25.3705 10.352 25.3435C10.643 25.237 12.9189 22.5716 14.3304 20.6839C16.7471 17.4522 18.4816 14.2669 19.1403 11.851C19.8295 9.32327 19.4487 6.76735 18.067 4.649C16.812 2.72477 14.7648 1.28058 12.4461 0.683879C11.3363 0.398272 9.64651 0.309132 8.52855 0.477183ZM11.0631 5.05639C13.2027 5.53724 14.6825 7.31153 14.685 9.39926C14.6867 10.7195 14.2229 11.7784 13.2441 12.6886C12.3471 13.5229 11.2368 13.9464 9.95089 13.9446C8.68193 13.9429 7.61038 13.5273 6.70636 12.6866C5.72994 11.7784 5.26605 10.7184 5.26766 9.39926C5.26911 8.19311 5.73164 7.11855 6.61233 6.27521C7.76598 5.17053 9.48112 4.7008 11.0631 5.05639Z",
    fill: "#57bdd7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.4fb74dd8bc951ca4bf81441467e19382.svg";
export { ForwardRef as ReactComponent };